import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import moment from 'moment';

import DatePicker from 'react-datepicker';

class DateAndTimePickerPost extends Component {
  state = {
    startDate: null,
  };

  componentDidMount() {
    const {
      existingDate, name, handleDate,
    } = this.props;
    if (existingDate) {
      const startDate = new Date(existingDate);
      this.setState({
        startDate,
      });
      handleDate(name, moment(startDate).format());
    } else {
      handleDate(name, null);
    }
  }

  handleChange = (date) => {
    const { handleDate, name } = this.props;
    this.setState({
      startDate: date,
    });
    handleDate(name, moment(date).format());
  };

  render() {
    const {
      title, action, wFull, reset, name, className, resetButtonStyle,
    } = this.props;
    const { startDate } = this.state;
    return (
      <div className={`py-4 mb-4 ${wFull ? 'w-full' : 'w-1/5'}`}>
        <div>
          <span className="font-americaMonoRegular text-xs uppercase text-white">{title}</span>
        </div>
        <DatePicker
          selected={startDate}
          onChange={this.handleChange}
          showTimeSelect
          showYearDropdown
          fixedHeight
          timeFormat="HH:mm"
          timeIntervals={15}
          dateFormat="MMMM d, yyyy h:mm aa"
          timeCaption="time"
          className={`${(action === 'display' || action === 'delete') && 'bg-grey'} px-6 py-2 outline-none rounded-full mt-2 w-full text-sm ${className || 'mx-4'}`}
          withPortal
          disabled={action === 'display' || action === 'delete'}
        />
        {reset && (
          <button
            type="button"
            className={`${resetButtonStyle} font-americaMonoBold text-xxs mx-4 px-6 py-1 rounded-full bg-grey text-black uppercase bg-greyFilter mb-1 mt-1`}
            onClick={() => {
              this.setState({ startDate: null });
              reset(name);
            }}
          >
            Reset
          </button>
        )}
      </div>
    );
  }
}

DateAndTimePickerPost.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  existingDate: PropTypes.string,
  handleDate: PropTypes.func.isRequired,
  wFull: PropTypes.bool,
  reset: PropTypes.func,
  className: PropTypes.string,
  resetButtonStyle: PropTypes.string,
};

DateAndTimePickerPost.defaultProps = {
  existingDate: '',
  wFull: false,
  reset: null,
  className: '',
  resetButtonStyle: '',
};

export default DateAndTimePickerPost;
